import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { getIRTemplateSettings, toggleComponent, confirmDialogBox } from "../../../../redux/actions/ir_template_setting/ir_template_setting.actions"
import { MiniSpinner } from "../../../layouts/Spinner";


function IRTSList({ loading, ir_template_settings, getIRTemplateSettings, toggleComponent, confirmDialogBox }) {

    useEffect(() => {
        getIRTemplateSettings()
    },[])


    return (
        <div className="row">
            {
                loading ? <div className="col-6 justify-content-center py-5 px-5"><MiniSpinner/></div> :
                <>
                    {
                        ir_template_settings && ir_template_settings.map(ir => (
                            <div className="col-lg-2 col-sm-6 col-12">
                                <div className="card temp-box">
                                    <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                        <div className="mr-auto">
                                            <i className="ft ft-more-horizontal temp-box-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                { !ir.main_template && <button onClick={() => toggleComponent('edit_copy', ir)} class="dropdown-item" type="button">Edit</button> }
                                                { ir.is_default === 1 ? null : !ir.is_custom_template ? <button onClick={() => confirmDialogBox('set_default', ir)} class="dropdown-item" type="button">Set as Default</button> : null}
                                                { ir.main_template ? <button onClick={() => toggleComponent('duplicate-main', ir)} class="dropdown-item" type="button">Duplicate</button> : <button onClick={() => toggleComponent('duplicate', ir)} class="dropdown-item" type="button">Duplicate</button> }
                                            </div>
                                        </div>
                                        <div className="pull-right">
                                            { ir.main_template !== 1 && <i onClick={() => confirmDialogBox('archive', ir)} className="ft ft-x temp-box-icon font-weight-bold"></i> }
                                        </div>
                                    </div>
                                    <div className="card-body my-0 p-0">
                                        <img src={ir.template_image} alt="ir" className="img-fluid cursor-pointer"/>
                                    </div>
                                </div>
                                <div className="text-center">{ ir.is_default === 1 && <i className="ft ft-check-circle temp-default-check"></i> } {ir.template_name}</div>
                                {
                                    ir.is_default === 1 && <div className="text-center text-primary"><span className="lbl-status temp-coming-soon">DEFAULT</span></div>
                                }
                            </div>
                        ))
                    }

                    <div className="col-lg-2 col-sm-6 col-12">
                        <div className="card temp-box">
                            <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                <div className="m-auto">
                                    <span className="mt-0 lbl-status temp-coming-soon">Coming Soon</span>
                                </div>
                            </div>
                            <div className="card-body my-0 p-0">
                                <span><i className="ft ft-plus-circle temp-plus-icon"></i></span>
                                <img src="/template-setting/blank.png" alt="ir" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}


const mapStateToProps = state => ({
    setting_app: state.setting_app,
    loading: state.ir_template_setting.loading,
    ir_template_settings: state.ir_template_setting.ir_template_settings
});

export default connect(mapStateToProps, { getIRTemplateSettings, toggleComponent, confirmDialogBox })(IRTSList);
